<template>
  <div class="tabbar-page">
    <van-tabbar v-model="activeTabIndex" @change="changeTabbar">
      <van-tabbar-item icon="home-o" @click="$router.push('birthday')">
        首页
      </van-tabbar-item>
      <van-tabbar-item icon="birthday-cake-o" @click="$router.push({ path: 'goods-list', query: { cateId: '3' } })">
        糕点
      </van-tabbar-item>
      <van-tabbar-item icon="coupon-o" @click="$router.push({ path: 'goods-list', query: { cateId: '4' } })">
        电子券
      </van-tabbar-item>
      <van-tabbar-item icon="contact-o" @click="$router.push({ path: 'user-center-index' })" class="budo-13"> 我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "tabBarBirthday",

  data() {
    return {
      activeTabIndex: 0,
      cateId: "",
    };
  },

  props: {
    active: { type: Number, default: 0 },
  },

  computed: {
    goodsCount: function () {
      const cart = this.$store.getters.cart;
      if (cart && Array.isArray(cart) && cart.length > 0) {
        return cart.length;
      }
      return 0;
    },
  },

  created() {
    this.activeTabIndex = this.active;
  },

  methods: {
    changeTabbar(index) {
      this.activeTabIndex = index;
      budo_log.info("#65 index", index);
    },

    toGoodList(path, cateId) {
      this.cateId = cateId;
      this.$router.push({
        path,
        query: { cateId, fromBirthday: "1" },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
